import { useListing } from 'framework-listing-lib/internal/providers/ListingProvider';
export default function useObjectTypeId() {
  "use memo";

  const {
    objectType
  } = useListing();
  return objectType;
}